/**
 * @generated SignedSource<<68f079e47766514f22dc671858d37052>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
import { Semver } from "@/common/relayCustomScalar";
export type CreateDatasetVersionInput = {
  datasetVersionId?: string | null | undefined;
  version?: Semver | null | undefined;
};
export type DatasetVersionCreateButtonMutation$variables = {
  datasetId: string;
  input: CreateDatasetVersionInput;
};
export type DatasetVersionCreateButtonMutation$data = {
  readonly createDatasetVersion: {
    readonly dataset: {
      readonly slug: string;
      readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionCreateButtonFragment" | "DatasetVersionHistoryFragment">;
    };
    readonly id: string;
    readonly version: Semver;
    readonly " $fragmentSpreads": FragmentRefs<"CardVersionHistoryFragment" | "DatasetUseButtonFragment" | "DatasetVersionAsideContentFragment">;
  };
};
export type DatasetVersionCreateButtonMutation = {
  response: DatasetVersionCreateButtonMutation$data;
  variables: DatasetVersionCreateButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "datasetId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "datasetId",
    "variableName": "datasetId"
  },
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "version",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = [
  (v2/*:: as any*/),
  (v3/*:: as any*/)
],
v6 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageThumbnail",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v8/*:: as any*/),
    (v13/*:: as any*/),
    {
      "kind": "TypeDiscriminator",
      "abstractKey": "__isEntity"
    },
    (v14/*:: as any*/),
    (v15/*:: as any*/),
    (v2/*:: as any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "DatasetAnalytics",
  "kind": "LinkedField",
  "name": "analytics",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "downloadCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileSize",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "full",
  "storageKey": null
},
v20 = {
  "alias": "viewerCanDeleteDatasetVersion",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "DELETE_DATASET_VERSION"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"DELETE_DATASET_VERSION\")"
},
v21 = [
  {
    "kind": "Literal",
    "name": "action",
    "value": "UPDATE_DATASET_VERSION"
  }
],
v22 = {
  "alias": "viewerCanUpdateDatasetVersion",
  "args": (v21/*:: as any*/),
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"UPDATE_DATASET_VERSION\")"
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishable",
  "storageKey": null
},
v24 = {
  "alias": "viewerCanPublishDatasetVersion",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "PUBLISH_DATASET_VERSION"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"PUBLISH_DATASET_VERSION\")"
},
v25 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 5
  }
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DatasetVersionCreateButtonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DatasetVersion",
        "kind": "LinkedField",
        "name": "createDatasetVersion",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Dataset",
            "kind": "LinkedField",
            "name": "dataset",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "DatasetVersionCreateButtonFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "DatasetVersionHistoryFragment"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CardVersionHistoryFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DatasetUseButtonFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DatasetVersionAsideContentFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "DatasetVersionCreateButtonMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DatasetVersion",
        "kind": "LinkedField",
        "name": "createDatasetVersion",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Dataset",
            "kind": "LinkedField",
            "name": "dataset",
            "plural": false,
            "selections": [
              (v4/*:: as any*/),
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "DatasetVersion",
                "kind": "LinkedField",
                "name": "latestVersion",
                "plural": false,
                "selections": (v5/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": "latestCreatedVersion",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  }
                ],
                "concreteType": "DatasetVersionConnection",
                "kind": "LinkedField",
                "name": "versions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DatasetVersion",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": (v5/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": "versions(first:1)"
              },
              {
                "alias": "versionsInput",
                "args": (v6/*:: as any*/),
                "concreteType": "DatasetVersionConnection",
                "kind": "LinkedField",
                "name": "versions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DatasetVersionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DatasetVersion",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*:: as any*/),
                          (v3/*:: as any*/),
                          (v7/*:: as any*/),
                          (v8/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v9/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v10/*:: as any*/)
                ],
                "storageKey": "versions(first:20)"
              },
              {
                "alias": "versionsInput",
                "args": (v6/*:: as any*/),
                "filters": null,
                "handle": "connection",
                "key": "DatasetVersionCreateButtonFragment_versionsInput",
                "kind": "LinkedHandle",
                "name": "versions"
              },
              (v11/*:: as any*/),
              {
                "alias": null,
                "args": (v12/*:: as any*/),
                "concreteType": "DatasetVersionConnection",
                "kind": "LinkedField",
                "name": "versions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DatasetVersionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "DatasetVersion",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*:: as any*/),
                          (v3/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Dataset",
                            "kind": "LinkedField",
                            "name": "dataset",
                            "plural": false,
                            "selections": [
                              (v2/*:: as any*/),
                              (v4/*:: as any*/),
                              (v16/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v17/*:: as any*/),
                          (v18/*:: as any*/),
                          (v7/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DOI",
                            "kind": "LinkedField",
                            "name": "doi",
                            "plural": false,
                            "selections": [
                              (v19/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v20/*:: as any*/),
                          (v22/*:: as any*/),
                          (v23/*:: as any*/),
                          (v24/*:: as any*/),
                          (v8/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v9/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v10/*:: as any*/)
                ],
                "storageKey": "versions(first:10)"
              },
              {
                "alias": null,
                "args": (v12/*:: as any*/),
                "filters": null,
                "handle": "connection",
                "key": "ListVersionHistoryFragment_versions",
                "kind": "LinkedHandle",
                "name": "versions"
              },
              {
                "alias": "versionsHelmet",
                "args": null,
                "concreteType": "DatasetVersionConnection",
                "kind": "LinkedField",
                "name": "versions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DatasetVersion",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v2/*:: as any*/),
                      (v3/*:: as any*/),
                      (v7/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "viewerCanCreateDatasetVersion",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "action",
                    "value": "CREATE_DATASET_VERSION"
                  }
                ],
                "kind": "ScalarField",
                "name": "viewerCan",
                "storageKey": "viewerCan(action:\"CREATE_DATASET_VERSION\")"
              },
              (v16/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "shortDescription",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "private",
                "storageKey": null
              },
              {
                "alias": "viewerCanUpdate",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "action",
                    "value": "UPDATE_DATASET"
                  }
                ],
                "kind": "ScalarField",
                "name": "viewerCan",
                "storageKey": "viewerCan(action:\"UPDATE_DATASET\")"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": "tagList",
                    "args": (v25/*:: as any*/),
                    "concreteType": "TaggableConnection",
                    "kind": "LinkedField",
                    "name": "tags",
                    "plural": false,
                    "selections": [
                      (v26/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TagEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Tag",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v2/*:: as any*/),
                              (v11/*:: as any*/),
                              (v8/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v9/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v10/*:: as any*/)
                    ],
                    "storageKey": "tags(first:5)"
                  },
                  {
                    "alias": "tagList",
                    "args": (v25/*:: as any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "TagListFragment_tagList",
                    "kind": "LinkedHandle",
                    "name": "tags"
                  }
                ],
                "type": "Taggable",
                "abstractKey": "__isTaggable"
              }
            ],
            "storageKey": null
          },
          (v17/*:: as any*/),
          (v18/*:: as any*/),
          (v7/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DOI",
            "kind": "LinkedField",
            "name": "doi",
            "plural": false,
            "selections": [
              (v19/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "short",
                "storageKey": null
              },
              (v27/*:: as any*/)
            ],
            "storageKey": null
          },
          (v20/*:: as any*/),
          (v22/*:: as any*/),
          (v23/*:: as any*/),
          (v24/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DatasetVersionFileConnection",
            "kind": "LinkedField",
            "name": "files",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DatasetVersionFile",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v28/*:: as any*/),
                  (v27/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "license",
            "storageKey": null
          },
          {
            "alias": "viewerCanUpdate",
            "args": (v21/*:: as any*/),
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"UPDATE_DATASET_VERSION\")"
          },
          (v28/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": "authorsPreview",
            "args": (v25/*:: as any*/),
            "concreteType": "DatasetVersionAuthorConnection",
            "kind": "LinkedField",
            "name": "authors",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "DatasetVersionAuthorConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  (v9/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v8/*:: as any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*:: as any*/),
                          (v13/*:: as any*/),
                          (v14/*:: as any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*:: as any*/)
                            ],
                            "type": "Entity",
                            "abstractKey": "__isEntity"
                          }
                        ],
                        "type": "User",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "fullName",
                            "storageKey": null
                          }
                        ],
                        "type": "UnregisteredUser",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*:: as any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v10/*:: as any*/)
            ],
            "storageKey": "authors(first:5)"
          },
          {
            "alias": "authorsPreview",
            "args": (v25/*:: as any*/),
            "filters": null,
            "handle": "connection",
            "key": "DatasetVersionAsideContentAuthorsFragment_authorsPreview",
            "kind": "LinkedHandle",
            "name": "authors"
          },
          {
            "alias": "authorsCount",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 0
              }
            ],
            "concreteType": "DatasetVersionAuthorConnection",
            "kind": "LinkedField",
            "name": "authors",
            "plural": false,
            "selections": [
              (v26/*:: as any*/)
            ],
            "storageKey": "authors(first:0)"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "22c2de9a6e4737b7a4ba54474fdff58b",
    "id": null,
    "metadata": {},
    "name": "DatasetVersionCreateButtonMutation",
    "operationKind": "mutation",
    "text": "mutation DatasetVersionCreateButtonMutation(\n  $datasetId: ID!\n  $input: CreateDatasetVersionInput!\n) {\n  createDatasetVersion(datasetId: $datasetId, input: $input) {\n    id\n    version\n    dataset {\n      slug\n      ...DatasetVersionCreateButtonFragment\n      ...DatasetVersionHistoryFragment\n      id\n    }\n    ...CardVersionHistoryFragment\n    ...DatasetUseButtonFragment\n    ...DatasetVersionAsideContentFragment\n  }\n}\n\nfragment CardVersionHistoryFragment on DatasetVersion {\n  id\n  version\n  dataset {\n    id\n    slug\n    owner {\n      __typename\n      username\n      ...EntityProfilePicFragment_49kWkb\n      id\n    }\n  }\n  analytics {\n    downloadCount\n    fileSize\n  }\n  updatedAt\n  publishedAt\n  doi {\n    full\n  }\n  viewerCanDeleteDatasetVersion: viewerCan(action: DELETE_DATASET_VERSION)\n  viewerCanUpdateDatasetVersion: viewerCan(action: UPDATE_DATASET_VERSION)\n  ...DatasetVersionPublishButtonFragment\n}\n\nfragment DatasetDOIFragment on DatasetVersion {\n  id\n  doi {\n    full\n    short\n    url\n  }\n}\n\nfragment DatasetUseButtonFragment on DatasetVersion {\n  version\n  files {\n    nodes {\n      size\n      url\n      id\n    }\n  }\n  dataset {\n    slug\n    id\n  }\n}\n\nfragment DatasetVersionAsideContentAuthorsFragment on DatasetVersion {\n  authorsPreview: authors(first: 5) {\n    edges {\n      cursor\n      node {\n        __typename\n        ... on User {\n          id\n          username\n          displayName\n          ...EntityProfilePicFragment_49kWkb\n        }\n        ... on UnregisteredUser {\n          fullName\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment DatasetVersionAsideContentFragment on DatasetVersion {\n  id\n  version\n  license\n  publishedAt\n  viewerCanUpdate: viewerCan(action: UPDATE_DATASET_VERSION)\n  doi {\n    full\n  }\n  dataset {\n    id\n    slug\n    name\n    shortDescription\n    private\n    viewerCanUpdate: viewerCan(action: UPDATE_DATASET)\n    ...TagListFragment\n    ...DatasetVersionCreateButtonFragment\n  }\n  ...DatasetVersionCardFragment\n  ...DatasetVersionEditSheet\n  ...DatasetVersionAsideContentAuthorsFragment\n  ...DatasetDOIFragment\n  authorsCount: authors(first: 0) {\n    totalCount\n  }\n}\n\nfragment DatasetVersionCardFragment on DatasetVersion {\n  id\n  version\n  size\n  publishedAt\n  createdAt\n  updatedAt\n  dataset {\n    id\n    slug\n    owner {\n      __typename\n      username\n      ...EntityProfilePicFragment_49kWkb\n      id\n    }\n  }\n  ...DatasetVersionPublishButtonFragment\n}\n\nfragment DatasetVersionCreateButtonFragment on Dataset {\n  id\n  latestVersion {\n    id\n    version\n  }\n  latestCreatedVersion: versions(first: 1) {\n    nodes {\n      id\n      version\n    }\n  }\n  versionsInput: versions(first: 20) {\n    edges {\n      node {\n        id\n        version\n        publishedAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment DatasetVersionEditSheet on DatasetVersion {\n  id\n  version\n  dataset {\n    slug\n    id\n  }\n}\n\nfragment DatasetVersionHistoryFragment on Dataset {\n  slug\n  name\n  ...ListVersionHistoryFragment\n  ...DatasetVersionsHelmetFragment\n  ...DatasetVersionCreateButtonFragment\n  viewerCanCreateDatasetVersion: viewerCan(action: CREATE_DATASET_VERSION)\n}\n\nfragment DatasetVersionPublishButtonFragment on DatasetVersion {\n  id\n  version\n  publishable @ifAllowed\n  viewerCanPublishDatasetVersion: viewerCan(action: PUBLISH_DATASET_VERSION)\n}\n\nfragment DatasetVersionsHelmetFragment on Dataset {\n  name\n  slug\n  versionsHelmet: versions {\n    nodes {\n      id\n      version\n      publishedAt\n    }\n  }\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n\nfragment ListVersionHistoryFragment on Dataset {\n  versions(first: 10) {\n    edges {\n      node {\n        id\n        ...CardVersionHistoryFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment TagFragment on Tag {\n  name\n}\n\nfragment TagListFragment on Taggable {\n  __isTaggable: __typename\n  tagList: tags(first: 5) {\n    totalCount\n    edges {\n      node {\n        id\n        ...TagFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "71fde4b2b534c6c283ec9940a7a40c2f";

export default node;
